var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangeLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "global, Earth, language, international, interface icon\n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,4A28,28,0,1,0,60,32,28,28,0,0,0,32,4ZM53.81,22H44.28a36.33,36.33,0,0,0-7.1-13.43A24.09,24.09,0,0,1,53.81,22ZM31.89,55.06h0A32.44,32.44,0,0,1,23.9,42H40.1a32.44,32.44,0,0,1-8,13.06A.18.18,0,0,1,31.89,55.06ZM22.89,38a33,33,0,0,1,0-12H41.11a33,33,0,0,1,0,12ZM8,32a23.77,23.77,0,0,1,.76-6H18.83a37,37,0,0,0,0,12H8.76A23.77,23.77,0,0,1,8,32ZM32,8.9a.15.15,0,0,1,.11,0A32.44,32.44,0,0,1,40.1,22H23.9a32.44,32.44,0,0,1,8-13.06A.15.15,0,0,1,32,8.9ZM45.17,26H55.24a24.06,24.06,0,0,1,0,12H45.17a37,37,0,0,0,0-12ZM26.82,8.57A36.48,36.48,0,0,0,19.72,22H10.19A24.09,24.09,0,0,1,26.82,8.57ZM10.19,42h9.53a36.33,36.33,0,0,0,7.1,13.43A24.09,24.09,0,0,1,10.19,42Zm27,13.43A36.48,36.48,0,0,0,44.28,42h9.53A24.09,24.09,0,0,1,37.18,55.43Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguageIcon);
export default __webpack_public_path__ + "static/media/changeLanguageIcon.49c66dd4243ae8889dfaafdbe384ef0c.svg";
export { ForwardRef as ReactComponent };